export default "__VITE_ASSET__a9a8bb7a__"